import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
	mode: 'history',
	routes: [
		{
			path: '/',
			name: 'Home',
			component: (resolve) => require(['@/views/Home.vue'], resolve),
		},
		{
			path: '/categories',
			name: 'categories',
			component: (resolve) => require(['@/views/categories.vue'], resolve),
		},
		{
			path: '/destination',
			name: 'destination',
			component: (resolve) => require(['@/views/destination.vue'], resolve),
		},
		{
			path: '/privacy',
			name: 'privacy',
			component: (resolve) => require(['@/views/privacy.vue'], resolve),
		},
		{
			path: '/Del',
			name: 'Del',
			component: (resolve) => require(['@/views/Del.vue'], resolve),
		},
		{
			path: '/PrivacyPolicy',
			name: 'PrivacyPolicy',
			component: (resolve) => require(['@/views/PrivacyPolicy.vue'], resolve),
		},

	],
})
